import { useState } from 'react';
import { ExtFormType } from 'api/extForms';
import type { AllStepsName, StepsName } from '../types';

/**
 * useExtFormStepController hook
 * Use this hook to handle the steps of the external form.
 *
 * @param data - external form data
 */
export const useExtFormStepController = (data?: ExtFormType) => {
  /**
   * Steps names
   */
  const steps: StepsName[] =
    data?.attachments && data.attachments.length
      ? ['form', 'attachments', 'otp']
      : ['form', 'otp'];

  /**
   * Current step name
   */
  const [currentStepsName, setCurrentStepsName] = useState<AllStepsName>(
    steps[0],
  );

  /**
   * Function to set the current step index by given name
   * @param name
   */
  const findActive = (name: string) => steps.findIndex(v => v === name);

  const nextStep = () =>
    setCurrentStepsName(
      current => steps[Math.min(steps.length, findActive(current) + 1)],
    );

  const prevStep = () =>
    setCurrentStepsName(current => steps[Math.max(0, findActive(current) - 1)]);
  const setStepByIndex = (stepIndex: number) =>
    setCurrentStepsName(steps[stepIndex]);

  const setStepByName = (stepName: AllStepsName) =>
    setCurrentStepsName(stepName);

  return {
    steps,
    currentStepsName,
    active: findActive(currentStepsName),
    nextStep,
    prevStep,
    setStepByIndex,
    setStepByName,
  };
};
